import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { User } from '../models';
import { userApi } from '../services/api';

interface UserAutocompleteProps {
  value: User[];
  onChange: (users: User[]) => void;
  label?: string;
  placeholder?: string;
}

const UserAutocomplete: React.FC<UserAutocompleteProps> = ({ value, onChange, label = 'Select Users', placeholder = 'Search by name, username, or email' }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!inputValue) {
      setOptions([]);
      return;
    }
    setLoading(true);
    const handler = setTimeout(async () => {
      try {
        const params = new URLSearchParams();
        params.append('search', inputValue);
        params.append('page_size', '10');
        const res = await userApi.getUsers(params.toString());
        setOptions(res.results || []);
      } catch {
        setOptions([]);
      }
      setLoading(false);
    }, 400);
    return () => clearTimeout(handler);
  }, [inputValue]);

  return (
    <Autocomplete
      multiple
      options={options}
      value={value}
      onChange={(_e, newValue) => onChange(newValue)}
      getOptionLabel={(option) => `${option.first_name} ${option.last_name} (${option.username})`}
      filterSelectedOptions
      loading={loading}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => setInputValue(newInputValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default UserAutocomplete;
